// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiTableCell-root{
  font-family: Segoe UI !important;
  font-size: 14px !important;
  padding: 8px 16px !important;
}
@media (min-height: 768px) {
  .MuiTableCell-root{
    font-family: Segoe UI !important;
    font-size: 14px !important;
    padding: 8px 16px !important;
  }
}
.MuiTableCell-head {
  font-family: Segoe UI !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  color: #000 !important;
  white-space: nowrap !important;
  padding: 12px 16px !important;
  border-bottom: 2px solid rgba(0, 0, 0, 0.12) !important;
  background-color: #fafafa !important;
}
@media (min-height: 768px) {
  .MuiTableCell-head {
    font-family: Segoe UI !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    color: #000 !important;
    white-space: nowrap !important;
    padding: 12px 16px !important;
    border-bottom: 2px solid rgba(0, 0, 0, 0.12) !important;
    background-color: #fafafa !important;
  }
}
.MuiTableCell-body {
  font-family: Segoe UI !important;
  opacity: 1 !important;
  font-weight: 400 !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06) !important;
}
.MuiPaper-elevation2{
  box-shadow: none !important;
}
table.MuiTable-root{
  border-top-color: transparent !important;
  border-collapse: separate !important;
  border-spacing: 0 !important;
}
th.MuiTableCell-head, td.MuiTableCell-root.MuiTableCell-body{
  line-height: 2.4rem;
}
td.MuiTableCell-root.MuiTableCell-body{
  border-bottom: 1px solid rgba(0, 0, 0, 0.06) !important;
}
.MTableToolbar-searchField-10 > div > input{
  color: #000 !important;
  font-size: 0.8em !important;
  font-weight: bolder !important;
  opacity: 1 !important;
}
.MTableHeader-header-13{
  z-index: 0 !important;
}
span.MuiButtonBase-root{
  font-size: 1.4rem;
  font-weight: 500;
}
span.MuiIconButton-label > span{
  color: #000;
}
span.MuiIconButton-label > span.MuiSwitch-thumb {
  color: #fafafa;
}
tr.MuiTableRow-root:not([path]):not(tr.MuiTableRow-head):not(tr.MuiTableRow-footer):not([style]){
  color: #000 !important;
}
.MuiTypography-caption{
  font-size: 14px !important;
  font-family: Segoe UI !important;
}
div.MuiButtonBase-root{
  font-size: 14px !important;
  font-family: Segoe UI !important;
}
.MuiChip-root {
  margin-top: 3px !important;
}
button.MuiButtonBase-root.MuiIconButton-root.MuiIconButton-colorInherit{
  margin: 0px;
  padding: 0px;
}
.MuiIconButton-root{
  font-size: 1.3rem !important;
}

.MuiPaper-root > div {
  overflow-x: auto !important;
}

.MuiTableBody-root td[colspan] {
  text-align: center !important;
  vertical-align: middle !important;
  padding: 40px 20px !important;
  font-size: 14px !important;
  color: #8C8C8B !important;
}
`, "",{"version":3,"sources":["webpack://./lib/clear-bi/grid/components/Grid.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;EACE;IACE,gCAAgC;IAChC,0BAA0B;IAC1B,4BAA4B;EAC9B;AACF;AACA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,6BAA6B;EAC7B,uDAAuD;EACvD,oCAAoC;AACtC;AACA;EACE;IACE,gCAAgC;IAChC,0BAA0B;IAC1B,2BAA2B;IAC3B,sBAAsB;IACtB,8BAA8B;IAC9B,6BAA6B;IAC7B,uDAAuD;IACvD,oCAAoC;EACtC;AACF;AACA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,2BAA2B;EAC3B,uDAAuD;AACzD;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uDAAuD;AACzD;AACA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;AACA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;AAC3B","sourcesContent":[".MuiTableCell-root{\n  font-family: Segoe UI !important;\n  font-size: 14px !important;\n  padding: 8px 16px !important;\n}\n@media (min-height: 768px) {\n  .MuiTableCell-root{\n    font-family: Segoe UI !important;\n    font-size: 14px !important;\n    padding: 8px 16px !important;\n  }\n}\n.MuiTableCell-head {\n  font-family: Segoe UI !important;\n  font-size: 12px !important;\n  font-weight: 600 !important;\n  color: #000 !important;\n  white-space: nowrap !important;\n  padding: 12px 16px !important;\n  border-bottom: 2px solid rgba(0, 0, 0, 0.12) !important;\n  background-color: #fafafa !important;\n}\n@media (min-height: 768px) {\n  .MuiTableCell-head {\n    font-family: Segoe UI !important;\n    font-size: 14px !important;\n    font-weight: 600 !important;\n    color: #000 !important;\n    white-space: nowrap !important;\n    padding: 12px 16px !important;\n    border-bottom: 2px solid rgba(0, 0, 0, 0.12) !important;\n    background-color: #fafafa !important;\n  }\n}\n.MuiTableCell-body {\n  font-family: Segoe UI !important;\n  opacity: 1 !important;\n  font-weight: 400 !important;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06) !important;\n}\n.MuiPaper-elevation2{\n  box-shadow: none !important;\n}\ntable.MuiTable-root{\n  border-top-color: transparent !important;\n  border-collapse: separate !important;\n  border-spacing: 0 !important;\n}\nth.MuiTableCell-head, td.MuiTableCell-root.MuiTableCell-body{\n  line-height: 2.4rem;\n}\ntd.MuiTableCell-root.MuiTableCell-body{\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06) !important;\n}\n.MTableToolbar-searchField-10 > div > input{\n  color: #000 !important;\n  font-size: 0.8em !important;\n  font-weight: bolder !important;\n  opacity: 1 !important;\n}\n.MTableHeader-header-13{\n  z-index: 0 !important;\n}\nspan.MuiButtonBase-root{\n  font-size: 1.4rem;\n  font-weight: 500;\n}\nspan.MuiIconButton-label > span{\n  color: #000;\n}\nspan.MuiIconButton-label > span.MuiSwitch-thumb {\n  color: #fafafa;\n}\ntr.MuiTableRow-root:not([path]):not(tr.MuiTableRow-head):not(tr.MuiTableRow-footer):not([style]){\n  color: #000 !important;\n}\n.MuiTypography-caption{\n  font-size: 14px !important;\n  font-family: Segoe UI !important;\n}\ndiv.MuiButtonBase-root{\n  font-size: 14px !important;\n  font-family: Segoe UI !important;\n}\n.MuiChip-root {\n  margin-top: 3px !important;\n}\nbutton.MuiButtonBase-root.MuiIconButton-root.MuiIconButton-colorInherit{\n  margin: 0px;\n  padding: 0px;\n}\n.MuiIconButton-root{\n  font-size: 1.3rem !important;\n}\n\n.MuiPaper-root > div {\n  overflow-x: auto !important;\n}\n\n.MuiTableBody-root td[colspan] {\n  text-align: center !important;\n  vertical-align: middle !important;\n  padding: 40px 20px !important;\n  font-size: 14px !important;\n  color: #8C8C8B !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
